import { Col, Grid, Row } from 'react-bootstrap'

import { ERROR_MESSAGE_TYPE } from '../../../constants/UserMessages'
import Loading from '../../../components/Loading'
import PropTypes from 'prop-types'
import React from 'react'
import UserMessage from '../../../components/saxs/UserMessage'
import { axios } from 'config/axios'

/**
 * React component used to retrieve info related to proposal such as all buffers, all macromolecules
 */
class SaxsRequester extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
      fetched: false,
      fetching: true,
      response: null,
      url: null,
    }
  }

  render() {
    // handles the loader
    if (this.state.fetching === true) {
      return <Loading />
    }

    // handles http request failure
    if (this.state.fetched === false && this.state.fetching === false) {
      return (
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <UserMessage type={ERROR_MESSAGE_TYPE} message="Retrieval of the data failed." />
            </Col>
          </Row>
        </Grid>
      )
    }

    // handles case when data have been recieved
    if (this.state.fetched === true) {
      return this.props.children(this.state.response)
    }
  }

  componentDidMount() {
    this.request()
  }

  componentDidUpdate() {
    if (this.props.url !== this.state.url) {
      this.request()
    }
  }

  request() {
    axios({
      method: 'GET',
      url: this.props.url,
    }).then(
      response => {
        response.data &&
          this.setState({
            response: this.props.parser(response.data),
            fetching: false,
            fetched: true,
            url: this.props.url,
          })
      },
      error => {
        this.setState({ error: error, fetching: false, fetched: false })
      }
    )
  }
}

export default SaxsRequester

SaxsRequester.propTypes = {
  /** url for the request */
  url: PropTypes.string.isRequired,
  /** parser used to parse the data in the http response */
  parser: PropTypes.func,
}
